module.exports = __webpack_public_path__ + "static/media/SuppliersAuditIcon.57a100b6.svg";